import { render, staticRenderFns } from "./NavigationBarItem.vue?vue&type=template&id=66dfd90e"
import script from "./NavigationBarItem.vue?vue&type=script&lang=js"
export * from "./NavigationBarItem.vue?vue&type=script&lang=js"
import style0 from "./NavigationBarItem.vue?vue&type=style&index=0&id=66dfd90e&prod&lang=sass&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports